import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import Feature from 'ol/Feature';
import MultiPoint from 'ol/geom/MultiPoint';
import MultiPolygon from 'ol/geom/MultiPolygon';
import { Vector as VectorLayer } from 'ol/layer';
import { fromLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { STYLES } from '@/define/olMaps';
import OlMap from '@/helpers/OlMap';

const Shoots = () => {
  const isShowShoots = useSelector((state) => state.map.isShowShoots);
  const latestShoots = useSelector((state) => state.editor.shoots);
  const layer = useRef();
  const map = OlMap.getMap();

  useUpdateEffect(() => {
    layer.current?.setVisible(isShowShoots);
  }, [isShowShoots]);

  useUpdateEffect(() => {
    // 영역 제거
    map.removeLayer(layer.current);

    if (latestShoots.length === 0) {
      layer.current = null;
      return;
    }

    // 촬영 영역
    const boundaries = latestShoots.map(({ boundary }) => boundary.map(({ lat, lng }) => fromLonLat([lng, lat])));
    const polygons = new Feature(new MultiPolygon([boundaries]));

    // 촬영 지점
    const positions = latestShoots.map(({ position }) => fromLonLat([position.lng, position.lat]));
    const points = new Feature(new MultiPoint(positions));

    const source = new VectorSource({ features: [polygons, points], wrapX: false });
    layer.current = new VectorLayer({
      source,
      visible: isShowShoots,
      declutter: true,
      style: STYLES.SHOOT.AREA,
    });

    map.addLayer(layer.current);
  }, [latestShoots]);

  return null;
};

export default Shoots;
